import { Component, Input } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { PonderAuthClient } from "@apiserver-rest/ponder-auth-client";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";

@Component({
    selector: "user-email-change",
    imports: [BusySpinComponent, ReactiveFormsModule],
    templateUrl: "./user-account-email-change.component.html"
})
export class UserAccountEmailChangeComponent {
    @Input({ required: true }) public authSession?: AuthSession;

    public updateEmailForm!: FormGroup;
    public isUpdating: boolean = false;
    public updateErrors?: string = undefined;

    private currEmail?: string;
    private hasEmailChanged: boolean = false;

    public constructor(formBuilder: FormBuilder, ponderAuthClient: PonderAuthClient) {
        this.updateEmailForm = formBuilder.group({
            email: ["", [Validators.required, Validators.email]]
        });

        this.updateEmailForm.valueChanges.subscribe(() => { this.onEmailChanged(); });
    }

    public ngOnChanges(): void {
        this.currEmail = this.authSession?.email;

        const formElement = this.updateEmailForm.get("email")!;

        if (this.currEmail && !formElement.value) {
            formElement.setValue(this.currEmail);
            this.updateEmailForm.disable({ emitEvent: false });
        }
    }

    private onEmailChanged(): void {
        this.hasEmailChanged = this.updateEmailForm.get("email")!.value != this.currEmail;
    }

    public canSubmitEmailChange(): boolean {
        return this.updateEmailForm.valid && !this.isUpdating && this.hasEmailChanged;
    }

    public onChangeEmailClicked(): void {
        if (!this.canSubmitEmailChange()) {
            return;
        }

        this.isUpdating = true;
        this.updateErrors = undefined;
        this.updateEmailForm.disable();

        // ... todo ...
    }
}